import actions from './materialsActions'
import mutations from './materialsMutations'
import getters from './materialsGetters'
import state from './materialsState'

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state,
}
